/* ISAIA · chip della collezione: accenno allo scorrimento (15-10-2026, provvisorio).
   Quando le chip non entrano nella riga, dopo 0,7 s la riga va avanti di 56 px e torna, una volta per pagina
   (e quando, ridimensionando, la riga inizia a non entrare). Stesso movimento della branch ROW
   new-mobile-on-page-chips-behaviour, che rifarà le chip. Niente movimento con "riduci animazioni". */
(function () {
  function hint() {
    var sc = document.querySelector('.subCollections__wrapper');
    if (!sc || sc.__isaiaHinted || sc.scrollWidth <= sc.clientWidth + 4) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sc.__isaiaHinted = true;
    // animazione a fotogrammi e non scroll-behavior smooth: stessi tempi su ogni browser
    function glide(to, ms, done) {
      var from = sc.scrollLeft, t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / ms), e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        sc.scrollLeft = from + (to - from) * e;
        if (p < 1) requestAnimationFrame(step); else if (done) done();
      }
      requestAnimationFrame(step);
    }
    setTimeout(function () {
      sc.style.setProperty('scroll-snap-type', 'none', 'important');   // l'aggancio tirerebbe la riga a scatti
      glide(Math.min(56, sc.scrollWidth - sc.clientWidth), 420, function () {
        setTimeout(function () { glide(0, 420, function () { sc.style.removeProperty('scroll-snap-type'); }); }, 100);
      });
    }, 700);
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(hint, 250); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hint); else hint();
})();
